import { Selector } from '@ngxs/store';

import { Language } from '@customer-portal/shared';

import { SettingsState, SettingsStateModel } from '../settings.state';

export class ProfileLanguageSelectors {
  @Selector([ProfileLanguageSelectors._portalLanguage])
  static portalLanguage(portalLanguage: Language): Language {
    return portalLanguage;
  }

  @Selector([SettingsState])
  private static _portalLanguage(state: SettingsStateModel): Language {
    return (state?.information?.portalLanguage ?? '') as Language;
  }
}
